<div class="info" [tooltip]="tooltipText" placement="right" [ngStyle]="{'top': top + 'px', 'right': right + 'px'}" >
    i
</div>